export default "__VITE_ASSET__2536d14d__"